import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { credentialImageURL, formatEarnedOnDate, getUserName } from '../../hooks/helpers';
import { DiscoverCredentialsModal } from '../DiscoverCredentialsModal';
import { IBLSpinLoader } from '../IBLSpinLoader';
import './CredentialLayoutBox.css';
import { ICredential } from '../../model';

interface CredentialLayoutBoxProps {
  userCredentials: ICredential[];
  userCredentialsLoaded: boolean;
  discoverCredentials: ICredential[];
  discoverCredentialsLoaded: boolean;
  searchTerm?: string;
}

export const CredentialLayoutBox: React.FC<CredentialLayoutBoxProps> = ({
  userCredentials = [],
  userCredentialsLoaded,
  discoverCredentials,
  discoverCredentialsLoaded,
  searchTerm = '',
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const filteredCredentials = userCredentials.filter(credential =>
    credential?.credentialDetails?.name?.toLowerCase().includes(searchTerm.toLowerCase()),


  );

  const renderCredentialLinks = () =>
    filteredCredentials.map((credential, index) => (
      <Link
        key={index}
        to={`/profile/credentials/${
          credential.credentialDetails.entityId
        }?user=${getUserName()}`}
        className="cr_link_box w-inline-block"
      >
        <div className="cr_box">
          <div className="cr_box_flex">
            <img
              alt=""
              className="image-153"
              src={credentialImageURL(credential)}
              onError={(e) =>
                (e.currentTarget.src = '/images/default_badge.png')
              }
            />
            <div>
              <div className="text-block-232">
                {credential.credentialDetails.name}
              </div>
              <div className="text-block-239">
                {credential.credentialDetails.issuerDetails.name}
              </div>
              <div className="text-block-239 date">
                Earned on: {formatEarnedOnDate(credential.issuedOn)}
              </div>
            </div>
          </div>
        </div>
      </Link>
    ));

  return (
    <>
      {userCredentialsLoaded ? (
        <>
          <div className="sk_cont">
            <div className="div-block-483">
              <div className="text-block-278">{`${filteredCredentials.length} Credentials`}</div>
              {/*{userCredentialsLoaded && (
                <div className="div-block-475 discover-credentials" onClick={() => setIsPopupOpen(true)}>
                  <h1>On Click Button</h1>
                  <div className="text-block-284 add_skill_text">Discover Credentials</div>
                </div>
              )}*/}
            </div>
            <div className="cr_row pp">
              <div
                prop-events-value-onclick="handleCreatePathwayClick"
                no-mapping=""
                prop-events-names="onClick"
                id="w-node-_617ef0ca-81f8-84cc-a337-8b500ce207cc-7c5fe5ef"
                className="item-box path_box"
              >
                <Link to="/discover" className="link-block-31 w-inline-block">
                  <div className="div-block-444">
                    <div className="div-block-394">
                      <img
                        src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66babee_plus.png"
                        loading="lazy"
                        alt=""
                        className="image-142"
                      />
                    </div>
                    <div className="c_p">Discover Credentials</div>
                  </div>
                </Link>
              </div>
              {renderCredentialLinks()}
            </div>
            {/*{!userCredentials.length && (
              <NoItemView displayMessage="You haven't earned any credentials yet." imageUrl="/images/tools.png" />
            )}*/}
          </div>
          {isPopupOpen && (
            <DiscoverCredentialsModal
              closePopUp={() => setIsPopupOpen(false)}
              discoverCredentials={discoverCredentials}
            />
          )}
        </>
      ) : (
        <IBLSpinLoader size={40} containerHeight="150px" />
      )}
    </>
  );
};
